const STATUS_CONFIG: Record<string, { dot: string; text: string; bg: string; border: string; label: string }> = {
  APPROVED:         { dot: "bg-emerald-500", text: "text-emerald-700", bg: "bg-emerald-50",  border: "border-emerald-200", label: "Approved" },
  REJECTED:         { dot: "bg-red-500",     text: "text-red-700",     bg: "bg-red-50",      border: "border-red-200",     label: "Rejected" },
  CANCELLED:        { dot: "bg-slate-400",   text: "text-slate-500",   bg: "bg-slate-100",   border: "border-slate-200",   label: "Cancelled" },
  PENDING_APPROVAL: { dot: "bg-amber-400",   text: "text-amber-700",   bg: "bg-amber-50",    border: "border-amber-200",   label: "Pending" },
  DRAFT:            { dot: "bg-slate-300",   text: "text-slate-500",   bg: "bg-slate-50",    border: "border-slate-200",   label: "Draft" },
  RECALLED:         { dot: "bg-orange-500",  text: "text-orange-700",  bg: "bg-orange-50",   border: "border-orange-200",  label: "Recalled" },
};

type Props = { value?: string | null };

export function LeaveStatusBadge({ value }: Props) {
  const cfg = STATUS_CONFIG[value ?? ""] ?? {
    dot: "bg-slate-300",
    text: "text-slate-500",
    bg: "bg-slate-50",
    border: "border-slate-200",
    label: value?.replaceAll("_", " ") ?? "—",
  };
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${cfg.bg} ${cfg.border} ${cfg.text}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
}
